import React, {Component} from "react";
import './OrderTableRow.css';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import Select from "react-select";
import {Modal} from "react-bootstrap";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import NumberFormatter from "../../../../Common/NumberFormatter/NumberFormatter";
import OrderItemProductionStatus from "./OrderItemProductionStatus/OrderItemProductionStatus";



class OrderTableRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            status: 'Pending review',
            showTrack: false,
            statusData: [],
            statusCode: '',
            productionResult:[]

        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.truncate = this.truncate.bind(this);
        this.getOrderStatus = this.getOrderStatus.bind(this);
    }

    onSubmit = event => {

        event.preventDefault();
        // this.saveStatus(); //TODO
        this.handleClose();
    };

    handleShow = () => {
        this.setState({
            show: true
        });
    };

    handleClose = () => {
        this.setState({show: false});
    };

    trackingOpen = () =>{
        this.setState({showTrack: true});
        // this.getOrderProductionStatus();
    };

    trackingClose =() =>{
      this.setState({
         showTrack : false
      });
    };

    changeStatus = (event) => {
        this.setState({
                status: event.value
            }
        )
    };

    truncate(s) {
        if(s.length>15){
            return s.substring(0, 12) + "...";
        }
        else {
            return s;
        }

    };

    getOrderStatus = () => {
        axios.get(RESOURCE_BASE_URL + 'api/jlcpcb/order/status/' + this.props.orders.orderUUID + '/' +this.props.orders.id)
            .then((res) => {
                this.setState({
                    statusData: res.data,
                    statusCode: res.data.orderStatus
                });
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };


    componentDidMount() {
        this.getOrderStatus();
    }

    render() {
        const options = [
            {value: 'Cancel', label: 'Cancel'},
            {value: 'Pending review', label: 'Pending review'},
            {value: 'Confirm', label: 'Confirm'},
            {value: 'Ordered', label: 'Ordered'},
            {value: 'In production', label: 'In production'},
            {value: 'Shipped', label: 'Shipped'}
        ];

        // console.log("ORDERSSSSSSSSSS ======> ", this.props.orders);

        let itemCount = 0;
        return (

            <div className="row no-padding">
                <div className="col-md-1 no-padding">
                    <span>{this.props.orders.id}</span>
                </div>
                <div className="col-md-2 no-padding">
                    <span>{this.props.orders.createdOn}</span>
                </div>
                {/**/}
                <div className="col-md-1 no-padding-left no-margin text-center">
                    <div>
                        {/*{this.props.orders.orderInfo.shippingMethod}*/}
                        dhl
                    </div>
                    {/*<div>*/}
                        {/*{this.truncate(this.props.orders.orderInfo.billingAddress.addressLine2+","+ this.props.orders.orderInfo.billingAddress.streetAddress)}*/}
                        {/*/!*{this.props.orders.orderInfo.billingAddress.addressLine2}*/}
                        {/*&nbsp;{this.props.orders.orderInfo.billingAddress.streetAddress}*!/</div>*/}
                    {/*<div>*/}
                        {/*{this.truncate(this.props.orders.orderInfo.billingAddress.city+","+this.props.orders.orderInfo.billingAddress.province)}*/}
                        {/*/!*{this.props.orders.orderInfo.billingAddress.city}*/}
                        {/*&nbsp;{this.props.orders.orderInfo.billingAddress.province}*!/</div>*/}

                </div>
                <div className="col-md-2 text-right all-order-money-values">
                    <span>
                        {this.props.orders.orderTotal !== null ? <NumberFormatter num = {this.props.orders.orderTotal}/> : 0}

                    </span>
                </div>

                <div className="col-md-2 text-right all-order-money-values">
                    <span>
                        {this.props.orders.orderTotal !== null ? <NumberFormatter num = {this.props.orders.orderTotal}/> : 0}

                    </span>
                </div>

                <div className="col-md-1">
                    <span>
                        {/*{this.state.status}*/}
                        <small>{this.props.orders.status}</small>

                    </span>
                </div>
                <div className="col-md-3 all-order-center-align">
                    <Link to={"view/" + this.props.orders.id} className="btn btn-xs btn-warning action-btn pull-right">
                        <FormattedMessage id="app.admin-all-row.view"
                                          defaultMessage="View"
                                          description=""/>
                    </Link>

                    <button className="btn btn-xs btn-success  action-btn pull-right" onClick={this.trackingOpen}>
                        <FormattedMessage id="app.admin-all-row.track"
                                          defaultMessage="Track"
                                          description=""/>
                    </button>
                    <div hidden={true}>
                        <button className="btn btn-xs btn-primary" onClick={this.handleShow} >
                            <FormattedMessage id="app.admin-all-row.status"
                                              defaultMessage="Status"
                                              description=""/>
                        </button>
                    </div>


                </div>

                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.admin.order.status"
                                              defaultMessage="CHANGE STATUS:"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row color-text">
                            <div className="col-md-3">
                                <label>
                                    <FormattedMessage id="app.admin.order.change-status"
                                                      defaultMessage="Change status to:"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="col-md-4">
                                <Select name="status"
                                        isLoading={true}
                                        isSearchable={true}
                                        defaultValue={this.state.status}
                                        options={options}
                                        onChange={this.changeStatus}
                                />
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className="row color-text">
                            <div className="col-md-2 pull-right">
                                <button className="btn btn-primary bottom-button" onClick={this.onSubmit}>
                                    <FormattedMessage id="app.admin.change.status.save"
                                                      defaultMessage="Save"
                                                      description=""/>
                                </button>
                            </div>
                            <div className="col-md-2">
                                <button className="btn btn-default bottom-button" onClick={this.handleClose}>
                                    <FormattedMessage id="app.admin.change.status.close"
                                                      defaultMessage="Close"
                                                      description=""/>
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal dialogClassName = "production-status-dialog" show={this.state.showTrack} onHide={this.trackingClose} className="track-order-modal">
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.site.track.production.title"
                                              defaultMessage="TRACK PRODUCTION PROCESS"
                                              description=""/>
                            {/*<span>{this.props.order.id}</span>*/}
                        </div>
                    </Modal.Header>
                    <Modal.Body>

                        <div className="row color-text">
                            <div className="col-md-4">
                                <label>
                                    <FormattedMessage id="app.site.track.production.order-id"
                                                      defaultMessage="Order ID: "
                                                      description=""/></label>
                            </div>
                            <div className="col-md-4 pull-left">
                                <span>{this.props.orders.id}</span>
                            </div>
                        </div>
                        <div className="row color-text">
                            <div className="col-md-4">
                                <label>
                                    <FormattedMessage id="app.site.track.production.batch-no"
                                                      defaultMessage="Batch No"
                                                      description=""/>:</label>
                            </div>
                            <div className="col-md-4 pull-left">
                                <span>{this.props.orders.batchNumber}</span>
                            </div>
                        </div>
                        <div className="row color-text">
                            <div className="col-md-4">
                                <label>
                                    <FormattedMessage id="app.site.track.production.order-status"
                                                      defaultMessage="Order Status: "
                                                      description=""/></label>
                            </div>
                            <div className="col-md-4 pull-left">
                                <span>
                                    {/*{this.state.status}*/}
                                    {this.state.statusCode}
                                </span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <hr className="quotation-summary-hr"/>
                            </div>
                        </div>
                        <div className="row color-text">

                            <div className="col-md-12 no-padding">
                                <div className="col-md-2"><label>
                                    <FormattedMessage id="app.site.track.production.item-id"
                                                      defaultMessage="Item ID"
                                                      description=""/>
                                </label></div>
                                <div className="col-md-2"><label>
                                    <FormattedMessage id="app.site.track.production.item-image"
                                                      defaultMessage="Image"
                                                      description=""/>
                                </label></div>
                                <div className="col-md-3">
                                    <label>
                                        <FormattedMessage id="app.site.track.production.begin-time"
                                                          defaultMessage="Begin Time"
                                                          description=""/>
                                        </label>
                                </div>
                                <div className="col-md-3">
                                    <label>
                                        <FormattedMessage id="app.site.track.production.end-time"
                                                          defaultMessage="End Time"
                                                          description=""/></label>
                                </div>
                                <div className="col-md-2 no-padding">
                                    <label>
                                        <FormattedMessage id="app.site.track.production.process-name"
                                                          defaultMessage="Process Name"
                                                          description=""/></label>
                                </div>
                            </div>
                            {/*<OrderItemProductionStatus orderItems = {this.props.orders.orderItems}/>*/}
                            {
                                this.props.orders.orderItems.map((item) => {
                                    return <OrderItemProductionStatus orderItem = {item}/>
                                })
                            }

                        </div>

                        {/*<div className="row color-text">
                            <div className="col-md-4">
                                <label>
                                    <FormattedMessage id="app.site.track.production.message"
                                                      defaultMessage="Message"
                                                      description=""/> : </label>
                            </div>
                            <div className="col-md-4 pull-left">
                                <span>{this.props.message}</span>
                            </div>
                        </div>*/}
                        {/*<div className="row color-text">*/}

                            {/*<div className="col-md-4">*/}
                                {/*<label>*/}
                                    {/*<FormattedMessage id="app.site.track.production.begin-time"*/}
                                                      {/*defaultMessage="Begin Time"*/}
                                                      {/*description=""/>: </label>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-4 pull-left">*/}
                                {/*<span>{this.state.productionResult.beginTime}</span>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        {/*<div className="row color-text">*/}

                            {/*<div className="col-md-4">*/}
                                {/*<label>*/}
                                    {/*<FormattedMessage id="app.site.track.production.end-time"*/}
                                                      {/*defaultMessage="End Time"*/}
                                                      {/*description=""/>: </label>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-4 pull-left">*/}
                                {/*/!*<span>{this.props.begintime}</span>*!/*/}
                                {/*<span>{this.state.productionResult.endTime}</span>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        {/*<div className="row color-text">*/}

                            {/*<div className="col-md-4">*/}
                                {/*<label>*/}
                                    {/*<FormattedMessage id="app.site.track.production.process-name"*/}
                                                      {/*defaultMessage="Process Name"*/}
                                                      {/*description=""/>: </label>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-4 pull-left">*/}
                                {/*<span>{this.state.productionResult.technicsProcessName}</span>*/}
                            {/*</div>*/}
                        {/*</div>*/}

                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-offset-2 pull-right color-text">
                            <button className="btn btn-info bottom-button" onClick={this.trackingClose}>
                                <FormattedMessage id="app.site.track.production.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>

        )
    }
}

export default OrderTableRow;



// WEBPACK FOOTER //
// ./src/components/Admin/Order/ViewAllOrders/OrderTableRow/OrderTableRow.js